/* eslint-disable */
export const LOCALE_UPDATE = 'locale_update';
export const ERROR_UPDATE = 'error_update';
export const ERROR_CLEAR = 'error_clear';
